import { log } from '../../services/utils';

import { noraApiRequest } from './';

export const downloadAsset = async guid => {
	log( '* download asset' );
	const response = await noraApiRequest( {
		url: `assets/download/${ guid }`,
		responseType: 'blob'
	} );

	// window.open( response.data );

	try {
		const blob = new Blob(
			[ response.data ],
			{ type: response.headers[ 'content-type' ] }
		);

		const metadata = await getDownloadMetadata( guid );

		const link = document.createElement( 'a' );

		link.href = window.URL.createObjectURL( blob );
		link.download = metadata.filename;
		link.click();
	} catch ( error ) {
		return error;
	}

	return true;
};

export const uploadAsset = async ( data, onUploadProgress = () => null ) => {
	log( '* upload file' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: 'assets/upload',
		data,
		headers: { Accept: 'multipart/form-data' },
		onUploadProgress
	} );

	return response.data;
};

export const getDownloadMetadata = async guid => {
	log( '* get download asset metadata' );
	const { data } = await noraApiRequest( { url: `assets/metadata/${ guid }` } );

	return data;
};
